import { noop } from '@fxts/core';

interface ITimer {
  duration: number;

  start(): this;
  pause(): this;
  resume(): this;
  clear(): this;
}

interface ITimerCallbackFn {
  onClear: () => unknown;
  onTick: () => unknown;

  // 필요하면 구현
  // onStart: <T>() => T;
  // onPause: <T>() => T;
}

export class IntervalTimer implements ITimer {
  public readonly duration: number;

  private timer: ReturnType<typeof setInterval> | null = null;

  // 마지막 실행 시작 시간
  private lastStartTime: number | null = null;

  // pause 했을 때 남은 시간
  private remainingTime: number | null = null;

  private readonly callbackFn: ITimerCallbackFn;

  constructor(duration: number, callbackFn: Partial<ITimerCallbackFn> = {}) {
    this.duration = duration;
    this.callbackFn = {
      onClear: callbackFn?.onClear ?? noop,
      onTick: callbackFn?.onTick ?? noop,
    };
  }

  // 타이머 시작
  public start(): this {
    if (!this.timer) {
      this.setTimer();
    }
    return this;
  }

  public pause(): this {
    this.clear();

    if (this.lastStartTime !== null) {
      this.remainingTime = this.duration - (Date.now() - this.lastStartTime);
    }
    return this;
  }

  public resume(): this {
    if (!this.timer) {
      if (this.remainingTime) {
        setTimeout(() => {
          this.setTimer();
          this.callbackFn.onTick();
        }, this.remainingTime);
        this.remainingTime = null;
      } else {
        this.setTimer();
      }
    }
    return this;
  }

  public clear(): this {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
      this.callbackFn.onClear();
    }
    return this;
  }

  private setTimer() {
    if (this.duration > 0) {
      this.lastStartTime = Date.now();

      this.timer = setInterval(() => {
        this.lastStartTime = Date.now();
        this.callbackFn.onTick();
      }, this.duration);
    }
  }
}
